import axios from 'axios'

// const url = `http://localhost:4000`
const url = process.env.REACT_APP_BACKEND_URL || `https://api.careerroshi.com`

export const AddUser = async (body) => {
    let result = await axios.post(`${url}/admin/user/create-user`, body)
    return result
}

export const FetchUsersList = async (page, limit, search, sort, filter = '') => {
    let result = await axios.get(`${url}/admin/alluserlist`, { params: { page, limit, search, sort, filter } })
    return result
}
export const FetchCoacheList = async (search) => {
    let result = await axios.get(`${url}/user/fetchCoatches`, { params: { search } })
    return result
}


export const FetchOrganizationList = async (search) => {
    let result = await axios.get(`${url}/organizations/fetch-organiztion-list`, { params: { search } })
    return result
}

export const FetchCoachSearchList = async (search) => {
    let result = await axios.get(`${url}/searchCoach`, { params: { search } })
    return result.data
}

export const FetchJobSeekerCoach = async (id) => {
    let result = await axios.get(`${url}/jobSeekerCoach/${id}`)
    return result.data
}

export const FetchJobSeekerByCoach = async (id) => {
    let result = await axios.get(`${url}/jobSeekerlist-by-coach/${id}`)
    return result.data
}

export const FetchDbStats = async () => {
    let result = await axios.get(`${url}/stats`)
    return result.data
}

export const AssignNewCoach = async (body) => {
    let result = await axios.post(`${url}/assignCoach/`, body)
    return result.data
}

export const FetchClient = async (id) => {
    let result = await axios.get(`${url}/user/${id}`)
    return result.data
}

export const UpdateUserAction = async (id, body) => {

    let res = await axios.put(`${url}/update-user/${id}`, body)
    return res.data

}

export const SendUserNewPasswordAction = async (id, body) => {

    let res = await axios.put(`${url}/user/send-new-password/${id}`, body)
    return res.data
}

export const BlockUnBlock = async (id, status) => {
    let res = await axios.post(`${url}/user/blockUnBlock/${id}`)
    return res.data
}

export const DeleteUser = async (id) => {
    let res = await axios.delete(`${url}/admin/user/${id}`)
    return res.data
}

export const UpdateType = async (id, type) => {
    let res = await axios.put(`${url}/admin/user/update/${id}`, {type})
    return res.data
}